import { ControlledInput } from '../form-controls';
import { useForm } from 'react-hook-form';
import '../../pages/login/login-page.css';
import { useState } from 'react';

export type LoginPageFields = {
  username: string;
  password: string;
};

interface LoginFormProps {
  onSubmit: (data: LoginPageFields) => void;
  error?: string; // Optional error property
}

export const LoginForm: React.FC<LoginFormProps> = ({ onSubmit, error }) => {
  const [showPassword, setShowPassword] = useState(false);
  const { handleSubmit, control } = useForm<LoginPageFields>({
    defaultValues: {
      username: '',
      password: '',
    },
  });

  return (
    <form className="login-form" onSubmit={handleSubmit(onSubmit)}>
      <ControlledInput
        control={control}
        name="username"
        rules={{ required: true }}
        inputProps={{
          placeholder: 'Username',
          className: 'input-form',
          fullWidth: true,
          autoFocus: true,
        }}
      />
      <div className="password-container">
        <ControlledInput
          control={control}
          name="password"
          rules={{ required: true }}
          inputProps={{
            type: showPassword ? 'text' : 'password',
            placeholder: 'Password',
            className: 'input-form',
            fullWidth: true,
          }}
        />
        <span className="toggle-password" onClick={() => setShowPassword(!showPassword)}>
          {showPassword ? '🔒' : '👀'}
        </span>
      </div>
      {error && (
        <p className="error-message" role="alert">
          {error}
        </p>
      )}
      <p>
        <a href="/forgot-password" className="forgot-password">
          Forgot Password?
        </a>
      </p>
      <button className="login-submit" type="submit">
        Login
      </button>
    </form>
  );
};
